import {Button, Checkbox, Col, Divider, Form, Input, List, Modal, Row, Select, Spin, Switch} from "antd";
import {LoadingOutlined} from "@ant-design/icons";
import ContainerComponent from "../../../helpers/components/container.component";
import PageHeaderComponent from "../../../helpers/components/page_header.component";
import globalHelper from "../../../helpers/functions/global.helper";
import React, {useState} from "react";
import {useHistory} from "react-router-dom";
import {useSelector} from "react-redux";

const RedemptionDetail = (props) => {

    const history = useHistory();
    const {activity} = props;
    const [state, setState] = useState({
        loading: false,
    });
    return (
        <>
            <Spin spinning={state?.loading} indicator={<LoadingOutlined/>}>
                <div style={{textAlign: 'start', marginBottom: 20,}}>
                    <div className='title-header mobile-padding-24'>
                        <ContainerComponent span={20}>
                            <PageHeaderComponent title={'Activity Details - Redemption'} textAlign={'start'}/>
                        </ContainerComponent>
                    </div>
                    <div
                        className='mobile-padding-24'
                        {...!globalHelper?.isMobileScreen() && ({style: {marginTop: 24,}})}
                    >
                        <ContainerComponent span={20}>
                            <div style={{ padding: '24px' }}>
                                <h2 style={{ marginBottom: '20px' }}>Activity Details</h2>

                                <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: '200px 1fr',
                                    rowGap: '12px',
                                    columnGap: '16px'
                                }}>
                                    <div><strong>Transaction No:</strong></div>
                                    <div>{activity?.transaction_no || '-'}</div>

                                    <div><strong>Transaction Type:</strong></div>
                                    <div>{activity?.transaction_type?.name || '-'}</div>

                                    <div><strong>Customer Name:</strong></div>
                                    <div>{activity?.to_wallet?.customer?.name || '-'}</div>

                                    <div><strong>Phone Number:</strong></div>
                                    <div>
                                        {activity?.to_wallet?.customer
                                            ? `${activity.to_wallet.customer.mobile_dial_no || ''}${activity.to_wallet.customer.phone_no || ''}`
                                            : '-'}
                                    </div>


                                    <div><strong>Wallet ID:</strong></div>
                                    <div style={{fontWeight: 600}}>{activity?.to_wallet?.name ?? '-'}</div>

                                    <div><strong>Redemption Code:</strong></div>
                                    <div
                                        style={{fontWeight: 600}}>{activity?.redemption?.redemption_code?.code ?? '-'}</div>

                                    <div><strong>Reference No:</strong></div>
                                    <div>{activity?.redemption?.redemption_code?.reference_no ?? '-'}</div>

                                    <div><strong>Created At:</strong></div>
                                    <div>{activity?.created_at ? new Date(activity.created_at).toLocaleString() : '-'}</div>

                                    <div><strong>Melon Amount:</strong></div>
                                    <div>{activity?.melon_amount ?? '-'}</div>

                                    <div><strong>Payment Amount:</strong></div>
                                    <div>
                                        {activity?.redemption?.payment_amount != null
                                            ? `${activity.redemption.redemption_code?.currency?.code || ''}${activity.redemption.payment_amount}`
                                            : '-'}
                                    </div>

                                    {/* Add more fields as needed */}
                                </div>
                            </div>
                        </ContainerComponent>

                    </div>
                </div>
            </Spin>
        </>
    );
};

export default RedemptionDetail;